import React from "react";
import {Button, Input, Modal} from "antd";
import "../styles/component/common/confirmActionModal.scss";

const {TextArea} = Input;

interface ConfirmActionModalProps {
    open: boolean;
    title?: string;
    subtitle?: string;

    // input
    showInput?: boolean;
    inputPlaceholder?: string;
    inputValue?: string;
    onInputChange?: (val: string) => void;

    // buttons
    confirmText?: string;
    cancelText?: string;

    // actions
    onConfirm: () => void;
    onCancel: () => void;

    // behavior
    confirmDisabled?: boolean;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
                                                                   open,
                                                                   title = "Are you sure?",
                                                                   subtitle = "",
                                                                   showInput = false,
                                                                   inputPlaceholder = "Enter reason",
                                                                   inputValue = "",
                                                                   onInputChange,
                                                                   confirmText = "Confirm",
                                                                   cancelText = "Cancel",
                                                                   onConfirm,
                                                                   onCancel,
                                                                   confirmDisabled = false
                                                               }) => {

    return (
        <Modal
            open={open}
            footer={null}
            onCancel={onCancel}
            centered
            className="hrms-app confirm-action-modal"
        >
            <div className="confirm-action-modal__content">

                <div className="confirm-action-modal__icon">!</div>

                <div className="confirm-action-modal__title">
                    {title}
                </div>

                {subtitle && (
                    <div className="confirm-action-modal__subtitle">
                        {subtitle}
                    </div>
                )}

                {showInput && (
                    <TextArea
                        value={inputValue}
                        onChange={(e) => onInputChange?.(e.target.value)}
                        placeholder={inputPlaceholder}
                        className="confirm-action-modal__input"
                        autoSize={{minRows: 3, maxRows: 5}}
                        maxLength={250}
                        showCount
                        autoFocus
                    />
                )}

                <div className="confirm-action-modal__actions">
                    <Button onClick={onCancel}>
                        {cancelText}
                    </Button>

                    <Button
                        type="primary"
                        danger
                        disabled={confirmDisabled}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </Button>
                </div>

            </div>
        </Modal>
    );
};

export default ConfirmActionModal;
